<template>
<div class="organ-detail">
  <div class="user-detail" v-if="detailUserInfo !== null">
    <div class="name">
      <div class="img-container">
        <UserAvatar :user-avatar="detailUserInfo.avatar"/>
      </div>
      <div class="name-detail">
        <div class="name-container">
          <div>{{detailUserInfo.name.slice(0, 5)}}</div>
          <div v-if="detailUserInfo.name.length>5">
            <span v-if="detailUserInfo.name.length>10">
              {{detailUserInfo.name.slice(5, 9)+'...'}}
            </span>
            <span v-else>
              {{detailUserInfo.name.slice(5)}}
            </span>
          </div>
        </div>
        <div class="position">
          <div>{{detailUserInfo.position.slice(0,9)}}</div>
          <div v-if="detailUserInfo.position.length>9">
            <span v-if="detailUserInfo.position>18">
              {{detailUserInfo.position.slice(9,17)+'...'}}
            </span>
            <span v-else>
              {{detailUserInfo.position.slice(9)}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="phone">
      <div>{{$t('addressBook.PhoneNumber')}}</div>
      <div>{{mobile}}</div>
    </div>
    <div class="company">
      <div>{{$t('personSetting.Company')}}</div>
      <div>
        <div>{{detailUserInfo.corpName.slice(0,12)}}</div>
        <div v-if="detailUserInfo.corpName.length>12">
          {{detailUserInfo.corpName.slice(12,24)}}
        </div>
        <div v-if="detailUserInfo.corpName.length>24">
          <span v-if="detailUserInfo.corpName.length>36">
            {{detailUserInfo.corpName.slice(24,35)+'...'}}
          </span>
          <span v-else>
            {{detailUserInfo.corpName.slice(24)}}
          </span>
        </div>
      </div>
    </div>
    <div class="email">
      <div>{{$t('addressBook.Mail')}}</div>
      <div>
        <div>{{detailUserInfo.email.slice(0,22)}}</div>
        <div v-if="detailUserInfo.email.length>22">
          {{detailUserInfo.email.slice(22,43)+'...'}}
        </div>
      </div>
    </div>
    <div
      class="call"
      @click="callMember"
      v-if="detailUserInfo.userId!==$store.state.userInfo.id"
    >
      <svg-icon icon-class="video"/>
      {{$t('home.CollaborateNow')}}
    </div>
  </div>
  <svg-icon icon-class="quarter-round" class-name="quarter-round" />
</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'
import { doubleCheck } from '@/utils/ops'
const { mapState } = createNamespacedHelpers('collaborator')

export default {
  name: 'OrganDetail',
  components: { UserAvatar },
  computed: {
    ...mapState(['detailUserInfo']),
    mobile() {
      if (this.detailUserInfo.mobile) {
        return this.detailUserInfo.mobile.replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3')
      }
      return ''
    }
  },
  methods: {
    callMember: doubleCheck(function() {
      const { corpId, userId, name: nickName, status } = this.detailUserInfo
      if (status === 0) {
        return this.$message.error(this.$t('home.NotOperateOfLogout'))
      }
      this.$store.dispatch('createAndStartImmediateConference', [{
        corpId,
        userId,
        nickName
      }])
    })
  }
}
</script>

<style scoped lang="less">
.organ-detail {
  position: relative;
  background: #F7F8FA;
  box-shadow: 5px 0 10px 0 rgba(151, 171, 199, 0.06);
}
.user-detail {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate3d(-50%,-50%,0);
  width: 480px;
  height: 560px;
  background-color: #fff;
  box-shadow: 0 5px 30px 0 rgba(89, 132, 219, 0.08);
  border-radius: 16px;
  border: 1px solid #EDEFF2;
  &>div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .name {
    justify-content: flex-start;
    margin-left: 120px;
    margin-top: 98px;
    &>.img-container {
      width: 88px;
      height: 88px;
      border-radius: 16px;
      margin-right: 24px;
      img, svg {
        width: 88px;
        height: 88px;
        border-radius: 16px;
      }
    }
    &>.name-detail {
      text-align: left;
      .name-container {
        div {
          height: 40px;
          font-size: 28px;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
        }
      }
      .position {
        margin-top: 8px;
        div {
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: #6A6D73;
          line-height: 22px;
        }
      }
    }
  }
  .company, .email {
    align-items: flex-start;
  }
  .phone, .company, .email {
    margin-top: 28px;
    justify-content: flex-start;
    margin-left: 120px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    &>div:nth-child(1) {
      margin-right: 32px;
    }
  }
  .company, .email {
    margin-top: 16px;
  }
  .call {
    margin: 48px auto 0;
    background-image: linear-gradient(154deg, #236CFF 0%, rgba(35, 108, 255, 0.8) 100%);
    box-shadow: 0 5px 10px 0 rgba(35, 108, 255, 0.5);
    color: #fff;
    cursor: pointer;
    &:hover {
      background-image: linear-gradient(154deg, #578fff 0%, #578fff 100%);
      box-shadow: 0 0 4px 4px rgba(35, 108, 255, 0.3);
    }
    &:active {
      background: #2C66DB;
      box-shadow: 0 5px 10px 0 rgba(35, 108, 255, 0.5);
    }
  }
  .share {
    margin: 24px auto 0;
    background: linear-gradient(136deg, #EFF3F8 0%, rgba(239, 243, 248, 0.8) 100%);
    box-shadow: 0 6px 10px 0 #CFDEF1;
    color: #236CFF;
    cursor: pointer;
  }
  .call, .share {
    width: 216px;
    height: 41px;
    border-radius: 20px;
    font-size: 16px;
    font-weight: 500;
    .svg-icon {
      width: 16px;
      margin-right: 7px;
    }
  }
}
.quarter-round {
  width: 549px;
  height: 579px;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 0;
}
</style>
